import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { NotificationService, UtilService } from '@app/core/services';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {
  data = {
    fetch: this.notificationService.getNotifications.bind(this.notificationService),
    ...this.util.generateGridData(),
    perPage: 50,
    currentPage: 1,
    sort: {}
  };
   @ViewChild('pageDropdown', { static: true }) private pageDropdownElem;
  query = '';
  totalPages = 0;
  pageArray = [];
  currentPage = 1;

  constructor(
    private util: UtilService,
    private notificationService: NotificationService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private location: Location
  ) {
  }

  ngOnInit() {
   // this.onScrollEndHandle(this.data);
    this.route.queryParams.subscribe(params => {
      if(typeof params.page != 'undefined') {
        this.currentPage = params.page
      }
    });
  //this.loadData();
    this.onPageChangeHandle(this.currentPage);
  }

  async onScrollEndHandle(data) {
    if (this.data.loading || !this.data.lastPage) {
      return;
    }


    data.loading = true;
    try {
      const response = await data.fetch(data.currentPage, data.perPage, this.query).toPromise();
        const updated = response.data.map(s => {
          this.totalPages = this.roundUp(response.total / this.data.perPage);
          return s;
        });

      data.currentPage++;
      //data.items = data.items.concat(response.data);
      data.items = response.data;
      this.pageArray = [];
      for(let i=1; i<=this.totalPages; i++){
        this.pageArray.push(i)
      }
      data.lastPage = response.next_page_url, scrollTo(0, 0);
    } catch (err) {
      this.toastr.error(err.message || 'Failed to load notifications.');
    } finally {
      this.data.loading = false;
      this.cdr.detectChanges();
      if (!this.data.items){
      }
    }
  }

async loadData(page = 0) {
    if (this.data.loading || !this.data.lastPage) {
      return;
    }
    if(!page) {
      page = this.data.currentPage;
    }

    this.data.loading = true;
    try {
      const response = await this.data.fetch(page, this.data.perPage, this.query).toPromise();
        const updated = response.data.map(s => {
          this.totalPages = this.roundUp(response.total / this.data.perPage);
          return s;
        });

      this.data.currentPage = page;
      //data.items = data.items.concat(response.data);
      this.data.items = response.data;
      this.pageArray = [];
      for(let i=1; i<=this.totalPages; i++){
        this.pageArray.push(i)
      }
      this.data.lastPage = response.next_page_url, scrollTo(0, 0);
    } catch (err) {
      this.toastr.error(err.message || 'Failed to load notifications.');
    } finally {
      this.data.loading = false;
      this.currentPage = this.data.currentPage;
      this.cdr.detectChanges();
      if (!this.data.items){
      }
    }
    this.setPageParam();
  }

async getNextSongs() {
  if (this.data.loading) return;

  this.data.loading = true;
  this.data.currentPage++;

  try {
    const response = await this.data.fetch(this.data.currentPage, this.data.perPage, this.query).toPromise();
    this.totalPages = this.roundUp(response.total / this.data.perPage);
    this.data.items = response.data;
    this.pageArray = Array.from({ length: this.totalPages }, (_, i) => i + 1);
    this.data.lastPage = response.next_page_url;

    // ✅ Keep the dropdown synced
    this.currentPage = this.data.currentPage;

    scrollTo(0, 0);
  } catch (err) {
    this.toastr.error(err.message || 'Failed to load notifications.');
  } finally {
    this.data.loading = false;
    this.cdr.detectChanges(); // ✅ ensures dropdown re-renders
    this.setPageParam();
  }
}


async getPrevSongs(){
  if (this.data.loading) {
    return;
  }
  if(this.data.currentPage<=1){
    return;
  }
  this.data.currentPage --;
  this.currentPage = this.data.currentPage;
  this.data.loading = true;
  const response = await this.data.fetch(this.data.currentPage, this.data.perPage, this.query).toPromise();
        const updated = response.data.map(s => {
          this.totalPages = this.roundUp(response.total / this.data.perPage);
          return s;
        });

    this.data.items = updated;
   // this.data.loadedAll = !result.next_page_url;
    this.data.loading = false;
    this.currentPage = this.data.currentPage;
    this.cdr.detectChanges();
   //this.pageDropdownElem.nativeElement.selectedIndex = (this.currentPage - 1)
   this.setPageParam();

 }

  onPageChangeHandle(page: number) {
    this.data.currentPage = +page; // ensure numeric
    this.currentPage = this.data.currentPage;
    this.data.loading = false;
    this.data.items = [];
    this.loadData(this.currentPage);
  }


  setPageParam() {
    // Single replaceState — avoid the browser's 100-calls/10s limit under fast scroll.
    const base = this.location.path().split('?')[0];
    this.location.replaceState(`${base}?page=${this.currentPage}`);
  }

  formatTime(time) {
    return this.util.datePeriod(time);
  }

  roundUp(num){
    this.totalPages = Math.ceil(num);
    return this.totalPages;
  }
  resetData() {
    this.data.items = [];
    this.data.loading = false;
    this.data.lastPage = 1;
    this.data.currentPage = 1;
  }

  onSearch(query) {
    this.query = query;
    this.resetData();
    this.onScrollEndHandle(this.data);
  }

  detectChanges() {
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }

  async readAll() {
    if (this.data.items && this.data.items.length === 0){
        return;
    }
    try {
      await this.notificationService.markAllAsRead().toPromise();
      this.data.items.forEach(notification => notification.read_at = true);
      this.detectChanges();
    } catch (err) {
      this.toastr.error(err.message || 'Failed to mark all as read.');
    }
  }

  async onClick(notification) {
    if (!notification.read_at) {
      this.markAsRead(notification);
    }
    const {link, extras} = this.util.getNotificationRoute(notification);
    if (link) {
      if (extras) {
        this.router.navigate(link, extras);
      } else {
        this.router.navigate(link);
      }
    }
  }

  getRoute(notification){
    const link = this.util.getNotificationRouteFormat(notification);
     if (link) {
         return link;
      }
  }

  async markAsRead(notification) {
    try {
      await this.notificationService.markNotificationAsRead(notification.id).toPromise();
      notification.read_at = true;
      this.detectChanges();
    } catch (err) {
      console.log(err);
    }
  }


  async clearAll(){
    if (this.data.items && this.data.items.length != 0){
      confirm("Do you really want to clear all notifications?")
    }
    try {
     await this.notificationService.clearAllNotifications().toPromise();
      this.detectChanges();
    } catch (err) {
      console.log(err);
      this.toastr.error(err.message || 'Failed to clear all notifications.');
    }
    this.resetData();
    this.detectChanges();
  }

  onSeeMore(){
    this.onScrollEndHandle(this.data)
  }

}
